import axios from 'axios'

const instance = axios.create({
  baseURL: '',
  timeout: 10000
})

const get = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    instance.get(url, { params }, {

    }).then(res => {
      resolve(res.data)
    }, e => {
      console.log(e)
      reject(e)
    })
  })
}

const post = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    instance.post(url, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      resolve(res.data)
    }, e => {
      console.log(e)
      reject(e)
    })
  })
}

const getMediaUploadToken = () => {
  return post('https://liuya.baichuanbailian.com/institutions/1.0/upload-token')
}

// 将七牛资源key上传拿到服务端的media
const uploadMediaKey = (data) => {
  return post('https://liuya.baichuanbailian.com/institutions/1.0/upload-key', data)
}

export { get, post, getMediaUploadToken, uploadMediaKey }



// WEBPACK FOOTER //
// ./src/utils/request.js